import React, { Component } from 'react';
import SearchIcon from '../../../../assets/common/images/icon/search.png'
import { trans } from '../../../../localization/index';

class SearchBarMenu extends Component {
  render() {
    const { searchText, onChangeSearchText } = this.props;

    return (
      <li className="sidebar-search-wrapper">
        <div className="sidebar-search">
          <div className="input-group">
            <button className="btn btn-submit">
              {/* <i className="icon icon-search" /> */}
              <img src={SearchIcon} alt="search icon" />
            </button>
            <input
              type="text"
              className="form-control"
              placeholder={trans('search_placeholder')}
              value={searchText}
              onChange={event => onChangeSearchText(event.target.value)}
            />
          </div>
        </div>
      </li>
    );
  }
}

export default SearchBarMenu;



// WEBPACK FOOTER //
// ./foody/src/layout/components/SidebarMenu/components/SearchBarMenu.jsx